module.exports = __webpack_public_path__ + "static/media/feedal.dfef2c89.svg";